<template>
   <div>
     <div class="search_unit"> 
        <div style='display:inline-block;'>
          <el-input placeholder="请输入不限补货数量会员名" v-model="username" class="input-with-select">
                    <el-button slot="append" icon="el-icon-plus" @click='addSpUser'>添加用户</el-button>
          </el-input>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="username"
        label="会员名">
      </el-table-column>
      <el-table-column
        label="开始时间">
      <template slot-scope="scope"> 
           {{scope.row.starttime | timeToDate}}
      </template>
      </el-table-column>
      <el-table-column
        label="结束时间">
      <template slot-scope="scope"> 
           {{scope.row.endtime | timeToDate}}
      </template>
      </el-table-column>
      <el-table-column
        label="权益">
      <template> 
           免运费，补货不限数量
      </template>
      </el-table-column>
      <el-table-column
        label="操作">
         <template slot-scope="scope"> 
          <el-button type="danger" @click="delSpUser(scope.row.userid)">删除</el-button>
         </template> 
      </el-table-column>
    </el-table>
     
   </div> 
</template>

<script>
export default {
  data(){
     return {
        tableData:[],
        username:'',
        processing:false
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/setting/getSpuserlist",{}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      delSpUser(userid){
        this.$post("/setting/delSpUser",{userid:userid}).then((data)=>{
             if(data.result.success){
                this.$message.success(data.result.info)
                this.getList()
             }else{
                this.$message.error(data.result.info)
             }
        })
      },
      addSpUser(){
         if(this.processing){
             this.$message("请等待操作完成");return false;
         }
         if(this.username==''){
             this.$message("请先输入会员名");return false;
         }
        
         this.processing=true
         this.$post("/setting/addSpUser",{username:this.username}).then((data)=>{
             this.processing=false
             if(data.result.success){
                this.$message.success(data.result.info)
                this.getList()
                this.username=''
             }else{
                this.$message.error(data.result.info)
             }
        })
      }
  }
}
</script>

<style scoped lang="scss">
.order-detail {font-size:14px;}
.order-detail li{padding: 0.1rem;list-style-type:none;border-bottom: 1px dashed #ccc;}
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
.checkimg{display: block;width: 100%;}
</style>
